"use strict";
/* eslint-disable @typescript-eslint/naming-convention */
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrate = void 0;
function migrate(old) {
    delete old.repository;
    var language = old.language;
    if (!language) {
        if (old.interface) {
            language = "interface";
        }
        else {
            language = "wasm/assemblyscript";
        }
    }
    return {
        __type: "Web3ApiManifest",
        format: "0.0.1-prealpha.5",
        build: old.build,
        language: language,
        modules: old.modules,
        import_redirects: old.import_redirects,
    };
}
exports.migrate = migrate;
//# sourceMappingURL=0.0.1-prealpha.3_to_0.0.1-prealpha.5.js.map